<!-- <tui-root>
  <div class="flex flex-row items-stretch max-w-full max-h-screen bg-background overflow-hidden">
    <app-side-bar></app-side-bar>
    <div class="fle flex-col w-full h-full">
      <app-top-bar></app-top-bar>
      <div class="pr-3 h-[calc(100vh-90px)]">
        <div
          class="bg-forground p-2 rounded-lg mb-4"
        >
        <div class="overflow-y-scroll w-full h-full p-2">
          <router-outlet></router-outlet>
        </div>
          
        </div>
      </div>
      <div class="pr-3">
        <app-footer></app-footer>
      </div>      
    </div>
  </div>
</tui-root> -->
<tui-root>
  <div class="flex flex-row items-stretch max-w-full max-h-screen bg-slate-100 overflow-hidden">
    <app-side-bar></app-side-bar>
    <div class="flex flex-col w-full">
      <app-top-bar></app-top-bar>
      <div class="flex flex-col flex-1 w-full p-3 h-full overflow-y-scroll">
        <div class="bg-white p-4 rounded-lg mb-4 flex-1 w-full">
          <router-outlet></router-outlet>
        </div>
        <div class="w-full">
          <app-footer></app-footer>
        </div>
      </div>      
    </div>
  </div>
</tui-root>
